import Script from 'next/script';

import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { EProductsId } from '@r1-frontend/shared/types/EProductsId';

import ErrorPage from '~/pages/_error';
import { getPriceOptions } from '~/src/entities/equipment';
import { convertShopPrices } from '~/src/entities/price';
import Layout from '~/src/features/_layout';
import { TEquipmentDetailsProps } from '~/src/features/equipment/shop/helpers';
import ContentPage from '~/src/features/work-in-home-ab/ContentPage';
import { capitalize } from '~/src/helpers/string';

type TProps = TEquipmentDetailsProps & {
    productId: EProductsId,
}

const ItemDetailPage = ({
    errorCode,

    city,
    companyName,
    category,
    basePath,
    productId,

    equipment,
    products,
}: TProps) => {
    if (!equipment) {
        return <ErrorPage statusCode={errorCode}/>;
    }

    const { callCenter, cityIn } = city;

    const {
        alias,
        globalId,
        image,
        prices: {
            leasing: [{ duration: leasingDuration = 0 } = {}],
        },
        props,
        title,
    } = equipment;

    const colorValue = props.find(item => item.name === 'colour')?.value;
    const color = Array.isArray(colorValue) ? colorValue[0] : (colorValue ?? '');
    const priceOptions = getPriceOptions(convertShopPrices(equipment));
    const purchaseMethodText = leasingDuration > 0 ? `в рассрочку на ${leasingDuration} месяцев` : 'купить';

    const linkedData = JSON.stringify({
        '@context': 'http://schema.org/',
        '@type': 'Product',
        brand: 'Дом.ру',
        name: title,
        description: `${capitalize(color)} ${title} ${purchaseMethodText} на официальном сайте ${companyName} в ${cityIn}: оформите заявку на получение оборудования на сайте или по ☎ ${callCenter}`.trim(),
        image,
        offers: {
            '@type': 'Offer',
            url: `${basePath}/${alias || globalId}`,
            availability: 'http://schema.org/InStock',
            priceCurrency: 'RUB',
            price: `${priceOptions[0].price}`,
            priceValidUntil: '2020-12-31',
        },
    });

    return (
        <>
            <Script
                id='mobile-app'
                type={'application/ld+json'}
                dangerouslySetInnerHTML={{ __html: linkedData }}
            />
            <Layout
                title={`Купить ${title} ${color.toLocaleLowerCase()} от ${companyName} в ${cityIn}`}
                description={
                    `${capitalize(color)} ${title} ${purchaseMethodText} на официальном сайте ${companyName} в ${cityIn}: оформите заявку на получение оборудования на сайте или по ☎ ${callCenter}`.trim()
                }
                withMenu={true}
                withChat={true}
                withFooter={true}
                bgColor={COLORS.BgMain}
            >
                <ContentPage
                    item={equipment}
                    category={category}
                    productId={productId}
                    products={products}
                />
            </Layout>
        </>
    );
};

export default ItemDetailPage;
